// Constants
import { LAYOUT_COMPONENT_FOOTER_CONFIGURATION_BUTTON_PROPS } from './constants/layout-footer.configuration.constants';
// Types
import { LayoutFooterConfigurationType } from './types/layout-footer.configuration.type';
// Types
import { LayoutFooterHookType } from '../hooks/types/layout-footer.hook.type';
// Utilities
import { buttonConfigurationIsLegit } from '../utils/layout-footer.utils';

const getLayoutFooterMainButtonConfiguration = ({
  buttonConfiguration,
  fetching: loading,
}: Pick<LayoutFooterHookType, 'buttonConfiguration' | 'fetching'>):
  | LayoutFooterConfigurationType
  | Record<string, unknown> =>
  buttonConfigurationIsLegit(buttonConfiguration)
    ? {
        mainButtonConfiguration: {
          loading,
          ...buttonConfiguration,
          ...LAYOUT_COMPONENT_FOOTER_CONFIGURATION_BUTTON_PROPS,
        },
      }
    : {};

export { getLayoutFooterMainButtonConfiguration };
